import React from 'react';

export const CheckIcon: React.FC<{ fill?: string }> = ({ fill = '#21B502' }) => (
    <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            d="M12 6C12 9.31372 9.31372 12 6 12C2.68628 12 0 9.31372 0 6C0 2.68628 2.68628 0 6 0C9.31372 0 12 2.68628 12 6ZM5.37789 9.10744L9.83764 4.70665C9.98908 4.55721 9.98908 4.3149 9.83764 4.16547L9.28921 3.62429C9.13777 3.47483 8.89222 3.47483 8.74076 3.62429L5.10366 7.21328L3.40558 5.53765C3.25414 5.38822 3.00859 5.38822 2.85713 5.53765L2.3087 6.07883C2.15726 6.22827 2.15726 6.47057 2.3087 6.62001L4.82943 9.10741C4.98089 9.25687 5.22642 9.25687 5.37789 9.10744Z"
            fill={fill}
        />
    </svg>
);
